import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Divider, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';

import { withRouter } from "common/utils/router.util";
const styles = theme => ({
  root: {
    paddingTop: theme.spacing(2),
    paddingRight: theme.spacing(4),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(4),
  },
  company: {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
});

class Footer extends Component {
  render() {
    const { classes, className } = this.props;

    const rootClassName = classNames(classes.root, className);

    return (
      <div className={rootClassName}>
        <Divider />
        <Typography className={classes.company} variant="subtitle2">
        &copy; ListGen Inc. {new Date().getFullYear()}
        </Typography>
        <Typography variant="caption">
          Committed to Continuous Improvement.
        </Typography>
      </div>
    );
  }
}

Footer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);
